import { useCallback, useEffect, useRef, useState } from 'react';

export function usePinEntry(length = 4, onComplete) {
  const [digits, setDigits] = useState([]);
  const pendingCompleteRef = useRef(null);

  useEffect(() => {
    const pendingComplete = pendingCompleteRef.current;
    if (!pendingComplete || digits.length !== length || digits.join('') !== pendingComplete) {
      return undefined;
    }

    pendingCompleteRef.current = null;
    let isStale = false;

    const accepted = onComplete(pendingComplete);
    if (accepted && typeof accepted.then === 'function') {
      accepted.then((resolved) => {
        if (!isStale && resolved === false) {
          setDigits([]);
        }
      });
    } else if (accepted === false) {
      setDigits([]);
    }

    return () => {
      isStale = true;
    };
  }, [digits, length, onComplete]);

  const append = useCallback(
    (digit) => {
      setDigits((current) => {
        if (current.length >= length) {
          return current;
        }

        const next = [...current, digit];
        if (next.length === length) {
          pendingCompleteRef.current = next.join('');
        }
        return next;
      });
    },
    [length]
  );

  const remove = useCallback(() => {
    setDigits((current) => current.slice(0, -1));
  }, []);

  const reset = useCallback(() => {
    setDigits([]);
  }, []);

  return { digits, append, remove, reset, length };
}
